export default "__VITE_ASSET__4JF7X5Ex__"